// ============================================================
//  FIREBASE CONFIG — ADMIN DASHBOARD
//  Path: src/config/firebase.ts
//
//  Uses Firebase Web SDK (not native SDK like mobile apps)
//
//  FIX (review pass):
//  - Removed getStorage / the `storage` export. Nothing in the
//    dashboard uses it any more — advertisement media now goes through
//    the backend's quarantine/scanner upload (admin.api.ts's
//    generateAdMediaUploadUrlApi), and every other file only mentions
//    Storage in comments. Dropping it takes the Firebase Storage SDK
//    out of the bundle and leaves no browser-side route into the
//    buckets. If anything still imported `storage`, the build now
//    fails with a clear error instead of shipping it.
//  - A build with a missing REACT_APP_FIREBASE_* value used to fail
//    only at sign-in, as Firebase's cryptic auth/invalid-api-key. It
//    now names the missing variable in the console at startup.
// ============================================================

import { initializeApp } from 'firebase/app'
import { getAuth }       from 'firebase/auth'

const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId:             process.env.REACT_APP_FIREBASE_APP_ID,
}

// Sign-in can't work without these. (storageBucket / messagingSenderId
// aren't needed for auth, so they aren't checked.)
const REQUIRED_ENV: Record<string, string | undefined> = {
  REACT_APP_FIREBASE_API_KEY:     firebaseConfig.apiKey,
  REACT_APP_FIREBASE_AUTH_DOMAIN: firebaseConfig.authDomain,
  REACT_APP_FIREBASE_PROJECT_ID:  firebaseConfig.projectId,
  REACT_APP_FIREBASE_APP_ID:      firebaseConfig.appId,
}
const missingEnv = Object.keys(REQUIRED_ENV).filter((name) => !REQUIRED_ENV[name])
if (missingEnv.length) {
  console.error(`[firebase] Missing build settings: ${missingEnv.join(', ')} — sign-in will fail. Set them in Cloudflare Pages (or .env) and rebuild.`)
}

const app  = initializeApp(firebaseConfig)
const auth = getAuth(app)

export { app, auth }